import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getBatchInfo, getBatchDetails, getProjectDetails, saveBatchDetails, saveProjectMasterDetails, getAllCandidates, getProjectBatchInfo, removeBatchMaster, removeProjectMaster } from '../actions/masterDataAction';

interface MasterState {
    loading: boolean;
    success: boolean;
    error: any;
    batchInfo: any;
    loading1: boolean;
    success1: boolean;
    error1: any;
    saveBatchInfo: any;
    //project master
    loading2: boolean;
    success2: boolean;
    error2: any;
    projectInfo: any;
    loading3: boolean;
    success3: boolean;
    error3: any;
    saveProjectInfo: any;
    //get individual batch data
    loading4: boolean;
    error4: any;
    success4: boolean;
    indvBatchInfo: any;
    loading5: boolean;
    error5: any;
    success5: boolean;
    allCandidInfo: any;
    //get project batch info
    loading6: boolean;
    error6: any;
    success6: boolean;
    indvPrjBtchInfo: any;
    //remove batch & project
    loading7: boolean;
    error7: any;
    success7: boolean;
    rmvBatchInfo: any;
    loading8: boolean;
    error8: any;
    success8: boolean;
    rmvPrjInfo: any;
}

const initialState: MasterState = {
    loading: false,
    success: false,
    error: null,
    batchInfo: null,
    loading1: false,
    success1: false,
    error1: null,
    saveBatchInfo: null,
    loading2: false,
    success2: false,
    projectInfo: null,
    error2: null,
    loading3: false,
    success3: false,
    saveProjectInfo: null,
    error3: null,
    loading4: false,
    error4: null,
    indvBatchInfo: null,
    success4: false,
    loading5: false,
    error5: null,
    success5: false,
    allCandidInfo: null,
    loading6: false,
    error6: null,
    success6: false,
    indvPrjBtchInfo: null,
    //remove batch & project
    loading7: false,
    error7: null,
    success7: false,
    rmvBatchInfo: null,
    loading8: false,
    error8: null,
    success8: false,
    rmvPrjInfo: null,
};

const masterSlice = createSlice({
    name: 'exam',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // questionpaper user
        builder
            .addCase(getBatchDetails.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.success = false;
                state.batchInfo = null;
            })
            .addCase(getBatchDetails.fulfilled, (state, { payload }) => {
                state.loading = false;
                state.batchInfo = payload;
                state.success = true;
            })
            .addCase(getBatchDetails.rejected, (state, { payload }) => {
                state.loading = false;
                state.error = payload;
                state.success = false;
            })
            .addCase(saveBatchDetails.pending, (state) => {
                state.loading1 = true;
                state.error1 = null;
                state.success1 = false;
                state.saveBatchInfo = null;
            })
            .addCase(saveBatchDetails.fulfilled, (state, { payload }) => {
                state.loading1 = false;
                state.saveBatchInfo = payload;
                state.success1 = true;
            })
            .addCase(saveBatchDetails.rejected, (state, { payload }) => {
                state.loading1 = false;
                state.error1 = payload;
                state.success1 = false;
            })
            .addCase(getProjectDetails.pending, (state) => {
                state.loading2 = true;
                state.error2 = null;
                state.success2 = false;
                state.projectInfo = null;
            })
            .addCase(getProjectDetails.fulfilled, (state, { payload }) => {
                state.loading2 = false;
                state.projectInfo = payload;
                state.success2 = true;
            })
            .addCase(getProjectDetails.rejected, (state, { payload }) => {
                state.loading2 = false;
                state.error2 = payload;
                state.success2 = false;
            })
            .addCase(saveProjectMasterDetails.pending, (state) => {
                state.loading3 = true;
                state.error3 = null;
                state.success3 = false;
                state.saveProjectInfo = null;
            })
            .addCase(saveProjectMasterDetails.fulfilled, (state, { payload }) => {
                state.loading3 = false;
                state.saveProjectInfo = payload;
                state.success3 = true;
            })
            .addCase(saveProjectMasterDetails.rejected, (state, { payload }) => {
                state.loading3 = false;
                state.error3 = payload;
                state.success3 = false;
            })
            .addCase(getBatchInfo.pending, (state) => {
                state.loading4 = true;
                state.error4 = null;
                state.success4 = false;
                state.indvBatchInfo = null;
            })
            .addCase(getBatchInfo.fulfilled, (state, { payload }) => {
                state.loading4 = false;
                state.indvBatchInfo = payload;
                state.success4 = true;
            })
            .addCase(getBatchInfo.rejected, (state, { payload }) => {
                state.loading4 = false;
                state.error4 = payload;
                state.success4 = false;
            })
            .addCase(getAllCandidates.pending, (state) => {
                state.loading5 = true;
                state.error5 = null;
                state.success5 = false;
                state.allCandidInfo = null;
            })
            .addCase(getAllCandidates.fulfilled, (state, { payload }) => {
                state.loading5 = false;
                state.allCandidInfo = payload;
                state.success5 = true;
            })
            .addCase(getAllCandidates.rejected, (state, { payload }) => {
                state.loading5 = false;
                state.error5 = payload;
                state.success5 = false;
            })
            .addCase(getProjectBatchInfo.pending, (state) => {
                state.loading6 = true;
                state.error6 = null;
                state.success6 = false;
                state.indvPrjBtchInfo = null;
            })
            .addCase(getProjectBatchInfo.fulfilled, (state, { payload }) => {
                state.loading6 = false;
                state.indvPrjBtchInfo = payload;
                state.success6 = true;
            })
            .addCase(getProjectBatchInfo.rejected, (state, { payload }) => {
                state.loading6 = false;
                state.error6 = payload;
                state.success6 = false;
            })
            .addCase(removeBatchMaster.pending, (state) => {
                state.loading7 = true;
                state.error7= null;
                state.success7 = false;
                state.rmvBatchInfo = null;
            })
            .addCase(removeBatchMaster.fulfilled, (state, { payload }) => {
                state.loading7 = false;
                state.rmvBatchInfo = payload;
                state.success7 = true;
            })
            .addCase(removeBatchMaster.rejected, (state, { payload }) => {
                state.loading7 = false;
                state.error7 = payload;
                state.success7 = false;
            })
            .addCase(removeProjectMaster.pending, (state) => {
                state.loading8 = true;
                state.error8 = null;
                state.success8 = false;
                state.rmvPrjInfo = null;
            })
            .addCase(removeProjectMaster.fulfilled, (state, { payload }) => {
                state.loading8 = false;
                state.rmvPrjInfo = payload;
                state.success8 = true;
            })
            .addCase(removeProjectMaster.rejected, (state, { payload }) => {
                state.loading8 = false;
                state.error8 = payload;
                state.success8 = false;
            });
    },
});

export default masterSlice.reducer;
